export class HelperService {
  changeClass(element, deletedClass, addedClass) {
    element.classList.remove(deletedClass);
    element.classList.add(addedClass);
  }

  toggleTwoClasses(element, firstClass, secondClass) {
    if (element.classList.contains(firstClass)) {
      element.classList.remove(firstClass);
      element.classList.add(secondClass);
    } else {
      element.classList.remove(secondClass);
      element.classList.add(firstClass);
    }
  }

  changeAttributeValue(element, attribute, firstValue, secondValue) {
    if (element.hasAttribute(attribute)) {
      if (element.getAttribute(attribute) === firstValue) {
        element.setAttribute(attribute, secondValue);
      } else {
        element.setAttribute(attribute, firstValue);
      }
    }
  }

  changeNodeTextValue(element, firstValue, secondValue) {
    if (element.textContent === firstValue) {
      element.textContent = secondValue;
    } else {
      element.textContent = firstValue;
    }
  }

  convertStringToHTML(str) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(str, 'text/html');

    return doc.body;
  }

  existsInArray(array, sought) {
    if (array.includes(sought)) {
      return true;
    }
    return false;
  }

  clearObject(obj) {
    for (const key in obj) {
      delete obj[key];
    }
  }

  emptyNode(node) {
    while (node.firstChild) {
      node.removeChild(node.firstChild);
    }
  }

  fillNode(objects, node) {
    objects.childNodes.forEach((element) => {
      node.appendChild(element);
    });
  }

  capitalizeFirstLetter(str) {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
}

export const HELPER = new HelperService();
